/* Platinversium product pages — design behaviour, wired to the theme's product-info events.
   Variant selection, price, quantity and add-to-cart are handled by the theme
   (variant-selects / product-info.js / product-form.js). This file only does the
   design layer: reveals, headline animation, gallery swapping and the sticky bar. */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function reveals(root) {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('in');
        e.target.querySelectorAll('.ua-bell').forEach(function (bell) {
          setTimeout(function () { bell.classList.add('on'); }, 260);
        });
        io.unobserve(e.target);
      });
    }, { threshold: 0.15 });
    root.querySelectorAll('.rv').forEach(function (el) { io.observe(el); });
  }

  /* animate-text "soft-blur-in": per-word blur reveal on the H1 */
  function softBlurIn(root) {
    root.querySelectorAll('.sbi').forEach(function (h) {
      var tmp = document.createElement('div');
      tmp.innerHTML = h.innerHTML;
      var frag = document.createDocumentFragment();
      Array.prototype.slice.call(tmp.childNodes).forEach(function (node) {
        if (node.nodeType === 3) {
          node.textContent.split(/(\s+)/).forEach(function (tok) {
            if (tok.trim() === '') { frag.appendChild(document.createTextNode(tok)); return; }
            var s = document.createElement('span');
            s.className = 'w';
            s.textContent = tok;
            frag.appendChild(s);
          });
        } else {
          if (node.classList) node.classList.add('w');
          frag.appendChild(node);
        }
      });
      h.innerHTML = '';
      h.appendChild(frag);
      var words = h.querySelectorAll('.w');
      if (reduce) {
        words.forEach(function (w) { w.style.opacity = 1; w.style.filter = 'none'; w.style.transform = 'none'; });
        return;
      }
      words.forEach(function (w, i) {
        w.animate(
          [{ opacity: 0, filter: 'blur(12px)', transform: 'translateY(16px)' },
           { opacity: 1, filter: 'blur(0px)', transform: 'translateY(0)' }],
          { duration: 900, delay: i * 90, easing: 'cubic-bezier(.22,1,.36,1)', fill: 'both' }
        );
      });
    });
  }

  /* Main gallery: thumbnails, plus the theme's variant change */
  function gallery(root) {
    var main = root.querySelector('.plv-main-img');
    var thumbs = root.querySelectorAll('.thumbs button');
    if (!main) return;

    function show(src, mediaId) {
      if (src) main.src = src;
      thumbs.forEach(function (t) {
        t.classList.toggle('on', mediaId != null
          ? t.dataset.mediaId === String(mediaId)
          : t.dataset.src === src);
      });
    }

    thumbs.forEach(function (b) {
      b.addEventListener('click', function () { show(b.dataset.src, b.dataset.mediaId); });
    });

    /* Swap the image the moment a swatch is picked. The theme also re-renders the
       section from the server, but that round trip is too slow to wait for.
       Delegated, because <variant-selects> is replaced on every variant change. */
    root.addEventListener('change', function (e) {
      var input = e.target;
      // each page styles its swatches differently (.ftile, .cwl, .samples) - the
      // thing they share is a radio inside the picker carrying its variant's image
      if (input.type !== 'radio' || !input.dataset.src) return;
      show(input.dataset.src, input.dataset.mediaId);
    });

    document.addEventListener('variant:change', function (e) {
      if (!e.detail || e.detail.sectionId !== root.dataset.section) return;
      var v = e.detail.variant;
      if (!v || !v.featured_media) return;
      var thumb = root.querySelector('.thumbs button[data-media-id="' + v.featured_media.id + '"]');
      show(thumb ? thumb.dataset.src : (v.featured_image && v.featured_image.src), v.featured_media.id);
    });
  }

  /* Secondary colour gallery in the feature zone (view only, no variant change) */
  function colourGallery(root) {
    var img = root.querySelector('.plv-farb-img');
    var tiles = root.querySelectorAll('.gtile');
    if (!img || !tiles.length) return;
    tiles.forEach(function (t) {
      t.addEventListener('click', function () {
        tiles.forEach(function (x) { x.classList.remove('on'); });
        t.classList.add('on');
        img.src = t.dataset.src;
      });
    });
  }

  /* Secondary price labels mirror the price block the theme keeps up to date */
  function priceEchoes(root) {
    var echoes = root.querySelectorAll('.plv-price-echo');
    if (!echoes.length) return;
    document.addEventListener('variant:change', function (e) {
      if (!e.detail || e.detail.sectionId !== root.dataset.section) return;
      var price = root.querySelector('#price-' + CSS.escape(root.dataset.section));
      if (!price) return;
      echoes.forEach(function (el) { el.innerHTML = price.innerHTML; });
    });
  }


  /* The band further down repeats the colour choice. Rather than a second source of
     truth, its buttons just click the matching variant input. */
  function colorways(root) {
    var buttons = root.querySelectorAll('.colorways button[data-name]');
    if (!buttons.length) return;

    function sync(name) {
      buttons.forEach(function (b) { b.classList.toggle('active', b.dataset.name === name); });
      root.querySelectorAll('.plv-cw-name').forEach(function (el) {
        var btn = root.querySelector('.colorways button[data-name="' + CSS.escape(name) + '"]');
        el.textContent = btn ? btn.dataset.label || name : name;
      });
    }

    buttons.forEach(function (b) {
      b.addEventListener('click', function () {
        var input = root.querySelector('.plv-colour input[value="' + CSS.escape(b.dataset.name) + '"]');
        if (input && !input.checked) input.click();
        sync(b.dataset.name);
      });
    });
    root.addEventListener('change', function (e) {
      if (e.target.matches && e.target.matches('.plv-colour input')) sync(e.target.value);
    });
    var checked = root.querySelector('.plv-colour input:checked');
    if (checked) sync(checked.value);
  }

  /* Ring page: 33 beads on a circle (3 x 11, every 11th gold). Scroll fills them,
     tapping the centre takes over as a manual counter — the real ring's gesture. */
  function beadDiagram(root) {
    var dia = root.querySelector('.diagram');
    var led = root.querySelector('.plv-led');
    var centre = root.querySelector('.plv-tap');
    if (!dia || !led) return;

    function build() {
      dia.querySelectorAll('.bead').forEach(function (b) { b.remove(); });
      var r = dia.clientWidth / 2 * 0.88;
      for (var i = 0; i < 33; i++) {
        var b = document.createElement('span');
        b.className = 'bead' + (i % 11 === 0 ? ' gold' : '');
        var a = (i / 33) * Math.PI * 2 - Math.PI / 2;
        b.style.transform = 'translate(' + (Math.cos(a) * r).toFixed(1) + 'px,' + (Math.sin(a) * r).toFixed(1) + 'px)';
        dia.appendChild(b);
      }
    }
    build();
    var resizeTimer;
    addEventListener('resize', function () { clearTimeout(resizeTimer); resizeTimer = setTimeout(build, 200); });

    var manual = false, count = 0;
    function render() {
      var beads = dia.querySelectorAll('.bead');
      var lit = manual ? (count % 33 === 0 && count > 0 ? 33 : count % 33) : count;
      beads.forEach(function (b, i) { b.classList.toggle('lit', i < lit); });
      led.textContent = count;
    }

    if (reduce) {
      count = 33; manual = true; render();
    } else {
      (function tick() {
        if (!manual) {
          var rect = dia.getBoundingClientRect();
          var p = (window.innerHeight - rect.top) / (window.innerHeight + rect.height);
          var n = Math.round(Math.max(0, Math.min(1, p * 1.45)) * 33);
          if (n !== count) { count = n; render(); }
        }
        requestAnimationFrame(tick);
      })();
    }

    function tap() {
      manual = true;
      count += 1;
      render();
      if (!reduce && centre.animate) {
        centre.animate([{ transform: 'scale(1)' }, { transform: 'scale(1.05)' }, { transform: 'scale(1)' }],
          { duration: 220, easing: 'cubic-bezier(.22,1,.36,1)' });
      }
    }
    if (centre) {
      centre.addEventListener('click', tap);
      centre.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); tap(); }
      });
    }
  }

  /* Sticky buy bar appears once the gallery section has scrolled past */
  function stickyBar(root) {
    var bar = root.querySelector('.plv-buybar');
    var top = root.querySelector('.top');
    if (!bar || !top) return;
    addEventListener('scroll', function () {
      bar.classList.toggle('show', scrollY > top.offsetTop + top.offsetHeight * 0.9);
    }, { passive: true });
  }

  function init(root) {
    if (root.dataset.plvInit) return;
    root.dataset.plvInit = '1';
    root.classList.add('js');
    reveals(root);
    softBlurIn(root);
    gallery(root);
    colourGallery(root);
    colorways(root);
    beadDiagram(root);
    priceEchoes(root);
    stickyBar(root);
  }

  function boot() { document.querySelectorAll('.plv-page').forEach(init); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  // theme editor re-renders sections without a page load
  document.addEventListener('shopify:section:load', boot);
})();
